import React from 'react';
import Icon from '../AppIcon';

const StatusIndicatorBadge = ({ status = 'draft', showIcon = true }) => {
  const statusConfig = {
    draft: {
      label: 'Draft',
      icon: 'FileEdit',
      className: 'draft',
    },
    pending: {
      label: 'Pending Review',
      icon: 'Clock',
      className: 'pending',
    },
    submitted: {
      label: 'Submitted',
      icon: 'Send',
      className: 'submitted',
    },
    approved: {
      label: 'Approved',
      icon: 'CheckCircle',
      className: 'approved',
    },
    rejected: {
      label: 'Rejected',
      icon: 'XCircle',
      className: 'rejected',
    },
  };

  const config = statusConfig?.[status] || statusConfig?.draft;

  return (
    <span className={`status-badge ${config?.className}`}>
      {showIcon && <Icon name={config?.icon} size={14} />}
      <span>{config?.label}</span>
    </span>
  );
};

export default StatusIndicatorBadge;